
import GContainer from '../g-container';
import MarketoForm from '../../marketo-form';
import Intersect from '~/utils/intersect';

export default {
  name: 'g-footer-newsletter-signup',
  components: {
    GContainer,
    iconNewsletter: () => import('assets/svg/icons/icon-blog-newsletter.svg'),
    MarketoForm,
    Intersect,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formId: '1261',
      scriptLoading: false,
    };
  },
  methods: {
    loadMarketoScript() {
      if (this.$store) {
        this.scriptLoading = true;
        this.$store.commit('setLoadAssets', 'munchkin,marketo');
      }
    },
  },
};
